var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useGetModuleBuilderLayoutQuery, useGetModuleListQuery, useGetModuleWizardBuilderQuery, } from "@/store/api";
import { usePopup } from "@/hooks/layout";
import { Button } from "@mui/joy";
import Grid from "@toast-ui/react-grid";
import TuiGrid from "tui-grid";
import "tui-grid/dist/tui-grid.css";
import { useTranslation } from "react-i18next";
import { Pagination } from "@/components/dev/pagination";
import { tableOptions } from "../module";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import { popupCallbackRegistry } from "../module/subpanels/subpanelDisplay";
import DisplayField from "@/components/fields/displayField";
// TUI config
TuiGrid.setLanguage("en");
TuiGrid.applyTheme("default", tableOptions);
export default function WidgetSelectorSubpanel(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var widget = _a.widget;
    var payload = widget.payload;
    var subModule = payload.subModule, parentModuleName = payload.parentModuleName, callbackId = payload.callbackId, saveCallbackId = payload.saveCallbackId, field_defs = payload.field_defs, create_layout = payload.create_layout, parentRecordId = payload.parentRecordId;
    var _f = useState([]), where = _f[0], setWhere = _f[1];
    var dataModuleStudio = useGetModuleWizardBuilderQuery({}).data;
    var _g = useState(false), isCreate = _g[0], setIsCreate = _g[1];
    var _h = useState([]), editedRecord = _h[0], setEditedRecord = _h[1];
    var _j = useState(new Map()), validations = _j[0], setValidations = _j[1];
    var _k = useState([]), record = _k[0], setRecord = _k[1];
    var _l = useState(0), currentPage = _l[0], setCurrentPage = _l[1];
    var _m = useState(0), key = _m[0], setkey = _m[1];
    var perPage = 10;
    var gridRef = useRef(null);
    var closePopup = usePopup().closePopup;
    var t = useTranslation([
        "common",
        subModule,
        parentModuleName,
        "ModuleBuilder",
    ]).t;
    var viewListDefs = useGetModuleBuilderLayoutQuery({
        moduleName: subModule || "Accounts",
        layout: "popupdefs",
    }).data;
    var layout = ((_b = viewListDefs === null || viewListDefs === void 0 ? void 0 : viewListDefs.data) === null || _b === void 0 ? void 0 : _b.layout) || {};
    var popupLayout = (_c = layout.listviewdefs) !== null && _c !== void 0 ? _c : layout;
    var popupLayoutSearch = (layout === null || layout === void 0 ? void 0 : layout.searchdefs) || {};
    var listLayout = useMemo(function () {
        if (!popupLayout)
            return [];
        return Object.entries(popupLayout).map(function (_a) {
            var key = _a[0], def = _a[1];
            return (__assign({ name: key.toLowerCase(), label: def.label }, def));
        });
    }, [popupLayout]);
    var subModuleData = useGetModuleListQuery({
        table: subModule,
        params: { where: where, count: true },
    }).data;
    useEffect(function () {
        var _a;
        var cleanedRecords = (((_a = subModuleData === null || subModuleData === void 0 ? void 0 : subModuleData.data) === null || _a === void 0 ? void 0 : _a.records) || [])
            .filter(function (r) { return r && typeof r === "object" && !Array.isArray(r); })
            .map(function (rec) {
            var _a;
            var filtered = {};
            for (var _i = 0, listLayout_1 = listLayout; _i < listLayout_1.length; _i++) {
                var col = listLayout_1[_i];
                filtered[col.name] = (_a = rec[col.name]) !== null && _a !== void 0 ? _a : "";
            }
            filtered._id = rec.id || rec.record_id;
            return {
                filtered: filtered,
                original: rec,
            };
        });
        setRecord(cleanedRecords);
        setCurrentPage(0);
    }, [subModuleData, listLayout]);
    /**
     * PAGINATION
     */
    var currentRecords = useMemo(function () {
        var start = currentPage * perPage;
        return record.slice(start, start + perPage).map(function (r) { return r.filtered; });
    }, [record, currentPage]);
    /**
     * GRID COLUMNS
     */
    var columns = useMemo(function () {
        return listLayout.map(function (field) { return ({
            name: field.name,
            header: t(field.label ? field.label : field.name, {
                ns: subModule || "common",
            }),
            align: "left",
            sortable: true,
        }); });
    }, [listLayout, t, subModule]);
    /**
     * CONFIRM SELECTION
     */
    var handleConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var grid, checkedRows, fullRecords, callback;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    grid = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.getInstance();
                    if (!grid)
                        return [2 /*return*/];
                    checkedRows = grid.getCheckedRows();
                    fullRecords = checkedRows.map(function (row) {
                        var _a;
                        return ((_a = record.find(function (r) { return r.filtered._id === row._id; })) === null || _a === void 0 ? void 0 : _a.original) || row;
                    });
                    callback = popupCallbackRegistry[callbackId];
                    if (!callback) return [3 /*break*/, 2];
                    return [4 /*yield*/, callback(fullRecords)];
                case 1:
                    _b.sent();
                    delete popupCallbackRegistry[callbackId];
                    _b.label = 2;
                case 2:
                    closePopup(widget.id, undefined, widget.slot);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * CREATE FLOW
     */
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var parentIdField, payloadData, saveCallback;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!editedRecord)
                        return [2 /*return*/];
                    parentIdField = "".concat((parentModuleName || "").toLowerCase(), "_id");
                    payloadData = __assign(__assign({}, editedRecord), (_a = {}, _a[parentIdField] = parentRecordId, _a));
                    saveCallback = popupCallbackRegistry[saveCallbackId];
                    if (!saveCallback) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveCallback(payloadData, subModule)];
                case 1:
                    _b.sent();
                    delete popupCallbackRegistry[saveCallbackId];
                    _b.label = 2;
                case 2:
                    closePopup(widget.id, undefined, widget.slot);
                    setIsCreate(false);
                    setEditedRecord([]);
                    return [2 /*return*/];
            }
        });
    }); };
    //SEARCH HERE
    var _o = useState({}), searchRecord = _o[0], setSearchRecord = _o[1];
    var normalizedSearchLayout = useMemo(function () {
        if (!popupLayoutSearch)
            return [];
        if (Array.isArray(popupLayoutSearch)) {
            return popupLayoutSearch.flat();
        }
        if (typeof popupLayoutSearch === "object") {
            return Object.values(popupLayoutSearch);
        }
        return [];
    }, [popupLayoutSearch]);
    var buildWhereFromSearch = function (search, tableName) {
        var rules = Object.entries(search)
            .filter(function (_a) {
            var _ = _a[0], value = _a[1];
            return value !== "" && value !== null && value !== undefined;
        })
            .map(function (_a) {
            var field = _a[0], value = _a[1];
            if (typeof value === "object" &&
                value !== null &&
                !Array.isArray(value)) {
                return {
                    field: field,
                    operator: "contains",
                    value: {
                        table: field.charAt(0).toUpperCase() + field.slice(1),
                        rules: buildWhereFromSearch(value).rules,
                    },
                };
            }
            else {
                return {
                    field: field,
                    operator: "contains",
                    value: value,
                };
            }
        });
        return {
            operator: "and",
            rules: rules,
        };
    };
    var isInModuleStudio = (_e = (_d = dataModuleStudio === null || dataModuleStudio === void 0 ? void 0 : dataModuleStudio.data) === null || _d === void 0 ? void 0 : _d.some(function (item) { return item.module === subModule; })) !== null && _e !== void 0 ? _e : false;
    return (_jsxs("div", __assign({ className: "w-[900px] max-h-[650px] space-y-3 overflow-auto bg-white rounded-md mt-5 shadow-lg" }, { children: [_jsx("div", __assign({ className: "w-full bg-gray-400 text-white p-2 px-5" }, { children: _jsxs("h3", __assign({ className: "font-semibold text-lg uppercase" }, { children: [subModule, " SEARCH"] })) })), normalizedSearchLayout.length > 0 ? (_jsxs("div", __assign({ className: "bg-gray-100 p-4 rounded mb-3" }, { children: [_jsx("div", __assign({ className: "grid grid-cols-2 gap-4" }, { children: normalizedSearchLayout.map(function (field) {
                            var fieldDef = field_defs === null || field_defs === void 0 ? void 0 : field_defs[field.name];
                            if (!fieldDef)
                                return null;
                            return (_jsx(DisplayField, { moduleName: subModule, fieldName: field.name, fieldLabel: t(field.label ? field.label : field.name, {
                                    ns: subModule || "common",
                                }), record: searchRecord, fieldDef: fieldDef, fieldMetadata: fieldDef, viewType: FieldViewType.EDIT, viewScreen: screenViewType.EDITVIEW, onUpdate: function (name, value) {
                                    setSearchRecord(function (prev) {
                                        var _a;
                                        return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
                                    });
                                } }, field.name));
                        }) })), _jsxs("div", __assign({ className: "flex justify-end mt-4 space-x-2" }, { children: [_jsx(Button, __assign({ size: "sm", onClick: function () {
                                    var whereClauses = buildWhereFromSearch(searchRecord);
                                    setWhere(whereClauses);
                                    setCurrentPage(0);
                                } }, { children: "Search" })), _jsx(Button, __assign({ size: "sm", variant: "outlined", onClick: function () {
                                    setSearchRecord({});
                                    setWhere([]);
                                    setCurrentPage(0);
                                    setkey(function (prev) { return prev + 1; });
                                } }, { children: "Clear" }))] }))] }), key)) : (_jsx("div", __assign({ className: "justify-center text-center p-5 italic text-gray-400" }, { children: t("LBL_UPDATE_LAYOUT_VIA_STUDIO", { ns: "ModuleBuilder" }) }))), !isCreate && isInModuleStudio && (_jsx("div", __assign({ className: "mb-5" }, { children: _jsxs(Button, __assign({ onClick: function () { return setIsCreate(true); } }, { children: ["CREATE ", subModule] })) }))), isCreate && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "w-full bg-gray-400 text-white p-2 px-5" }, { children: _jsxs("h3", __assign({ className: "font-semibold text-lg uppercase" }, { children: ["CREATE ", subModule] })) })), field_defs && create_layout && (_jsx(LayoutComponentDisplay, { module: subModule || "Accounts", viewType: FieldViewType.EDIT, record: editedRecord, fetchedRecord: editedRecord, layouts: create_layout.layout, fieldDefs: field_defs, viewScreen: screenViewType.EDITVIEW, onHandleUpdate: setEditedRecord, validations: validations })), _jsxs("div", __assign({ className: "my-2 space-x-2" }, { children: [_jsx(Button, __assign({ onClick: handleSave }, { children: "Save" })), _jsx(Button, __assign({ onClick: function () { return setIsCreate(false); } }, { children: "Cancel" }))] }))] })), _jsx("div", __assign({ className: "w-full bg-gray-400 text-white p-2 px-5" }, { children: _jsxs("h3", __assign({ className: "font-semibold text-lg uppercase" }, { children: [subModule, " LIST"] })) })), !record || record.length === 0 ? (_jsx("div", __assign({ className: "justify-center text-center p-5 italic text-gray-400" }, { children: t("LBL_EMPTY_LIST", { ns: "ModuleBuilder" }) }))) : popupLayout.length === 0 ? (_jsx("div", __assign({ className: "justify-center text-center p-5 italic text-gray-400" }, { children: t("LBL_UPDATE_LAYOUT_VIA_STUDIO", { ns: "ModuleBuilder" }) }))) : (_jsxs("div", __assign({ className: "relative px-2" }, { children: [_jsx(Pagination, { currentPage: currentPage, totalResult: record.length, elementPerPage: perPage, onChangePagination: function (e) { return setCurrentPage(e.selected); } }), _jsx(Grid, { ref: gridRef, data: currentRecords, rowHeaders: ["checkbox"], columns: columns, bodyHeight: 450, rowHeight: 35, columnOptions: { resizable: true } })] }))), _jsx("div", __assign({ className: "flex justify-end mt-4" }, { children: _jsx(Button, __assign({ onClick: handleConfirm }, { children: "Select" })) }))] })));
}
/**
 * REGISTER WIDGET
 */
widgetsDictionary.register("widget/selectorSubpanel", {
    name: "Selecteur de widget",
    display: WidgetSelectorSubpanel,
    selectable: false,
    editable: false,
});
